import { render, staticRenderFns } from "./man.vue?vue&type=template&id=7d312a6c&scoped=true"
import script from "./man.vue?vue&type=script&lang=js"
export * from "./man.vue?vue&type=script&lang=js"
import style0 from "./man.vue?vue&type=style&index=0&id=7d312a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d312a6c",
  null
  
)

export default component.exports